import { useLocale, useTranslations } from "next-intl"
import styles from "./FreeTrialExpired.module.css"
import Button, { ButtonKind, ButtonSize } from "../Buttons/Button/Button"
import LinkButton, { LinkButtonKind, LinkButtonSize } from "../Buttons/LinkButton/LinkButton"
import { useMemberships } from "@/apiUtilities/queries/useMemberships"
import getSymbolFromCurrency from 'currency-symbol-map'
import Image_FreeTrialExpired from "@/assets/img/Image_FreeTrialExpired.svg"
import Icon from "../Icon/Icon"
export default function FreeTrialExpired({ onClose } : { onClose: () => void }) {

	const t = useTranslations("Modals.FreeTrialExpired")
	const locale = useLocale()

	const { data, isSuccess } = useMemberships(locale)
	const intervals = useTranslations("Memberships.intervals")
	
	return (
		<div className={styles.main} data-testid="FreeTrialExpired">
			<Icon icon={Image_FreeTrialExpired} className={styles.icon} data-testid="FreeTrialExpired_icon"/>
			<h2 className="title2" data-testid="FreeTrialExpired_title">{t('title')}</h2>
			<p className="bodyTextLarge" data-testid="FreeTrialExpired_text">{t('text')}</p>
			{isSuccess && 
			<div className={styles.prices} data-testid="FreeTrialExpired_prices">
				{data.memberships[0].prices.map(price => {
					return (
						<div className={styles.price} key={price.price_id} data-testid="FreeTrialExpired_price">
							<div className={styles.costs} data-testid="FreeTrialExpired_priceCosts">
							{price.nominal_price && <div data-testid="FreeTrialExpired_priceCosts_nominalPrice" className={`${styles.nominalPrice} bodyTextSmall`}>{Number(price.nominal_price.amount) / 100}{getSymbolFromCurrency(price.nominal_price.currency)}</div>}
							{price.buy_price && <div data-testid="FreeTrialExpired_priceCosts_buyPrice" className={`${styles.buyPrice} largeButton`}>{Number(price.buy_price.amount) / 100}{getSymbolFromCurrency(price.buy_price.currency)}</div>}
							</div>
							{intervals(price.interval)}
						</div>
					)
				})}
			</div>
			}
			<div className={styles.buttons} data-testid="FreeTrialExpired_buttons">
				<Button kind={ButtonKind.SECONDARY} size={ButtonSize.MEDIUM} onClick={onClose} data-testid="FreeTrialExpired_closeButton">{t('no')}</Button>
				<LinkButton kind={LinkButtonKind.SUGGESTED} onClick={onClose} size={LinkButtonSize.MEDIUM} href={'/billing/choose-plan'} data-testid="FreeTrialExpired_choosePlanButton">{t('upgrade')}</LinkButton>
			</div>
		</div>
	)
}